import { useEffect, useRef } from 'react';
import { useFormik } from '@client/hooks/formik.hooks';
import { showSnackbar } from '@client/listeners/lib/snackbar';

export const ErrorHandler = () => {
  const wasSubmitting = useRef(false);

  const {
    isSubmitting, isValidating, errors, isValid,
  } = useFormik();

  useEffect(() => {
    if (wasSubmitting.current && !isSubmitting && !isValidating && !isValid && Object.keys(errors).length > 0) {
      console.log(errors);

      showSnackbar('There was an issue saving this form. Please check for errors and try again.', 'error');
    }

    wasSubmitting.current = isSubmitting;
  }, [isSubmitting, isValidating, errors, isValid]);

  return null;
};
